module.exports = __webpack_public_path__ + "00098c84f.jpg";